import React from 'react'
import {Link} from "react-router-dom";
import Icon from '../Icons/Icon'




const Breadcumb = ({ items }) => {
    return (
        <div class="breadcrumb-box">
            <ol class="breadcrumb">
            {
                items.map((item, index) => {
                return <li key={index}><Icon icon={item.icon} customClass="ift18 space-right" /> <Link to={item.page_path}>{item.page_title}</Link></li>
            })}
                  
            </ol>
        </div>
    )
}

export default Breadcumb
